<button
    class="map-button"
    [class.map-button--with-shadow]="!noShadow"
>
    <div class="map-button__content">
        <ng-content />
    </div>
</button>
